(function ($) {

    "use strict";

    // Handle search input text input
    $("#school-form .school-input-text").on("input", function () {
        schoolSearch($(this).val().toLowerCase());
    });

    // Search for blank on start
    var query = getUrlParameter("q");
    if (query !== "") {
        $("#school-form .school-input-text").val(query);
    }
    schoolSearch(query.toLowerCase());

    // Search for string and handle received data
    function schoolSearch(query) {

        $(".school-list__school").show();
        $(".school-list__no-hit").hide();

        if (query === "") {
            $(".school-list__letter").show();
            return;
        }

        $(".school-list__letter").hide();

        $(".school-list__school:not([data-school*='" + query + "'])").hide();

        if ($(".school-list__school:visible").length === 0) {
            $(".school-list__no-hit").show();
        }

        var letters = [];
        $(".school-list__school:visible").each(function() {
            var letter = $(this).data("school").substring(0, 1);
            letters.push(letter);
            $('.school-list__letter[data-letter="' + letter.toUpperCase() + '"]').show();
        });
    }

    $(".calendar-month-heading").click(function () {
        $(this).toggleClass("calendar-month-heading--open");
        $(".calendar-month[data-month=" + $(this).data("toggle-month") + "]").toggleClass('calendar-month--open');
    });

    function getUrlParameter(name) {
        return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.search) || [null, ""])[1].replace(/\+/g, '%20')) || "";
    }

})(jQuery);